import { useQuery } from "react-query"
import UserService from "~services/UserService"

const useUserByEmail = (email: string, callback?: any) => {
  return useQuery(
    ["user-email", email],
    () => UserService.getUserByEmail(email),
    {
      enabled: false,
      onSuccess: data => {
        if (!!callback && data) {
          const users = data._embedded.users

          if (users.length === 1) {
            callback(users[0])
          } else {
            const found = users.find(
              user => user.email?.toLowerCase() === email.toLowerCase()
            )
            callback(found || null)
          }
        }
      },
    }
  )
}

export default useUserByEmail
